// src/services/orderApi.js
import axios from 'axios';
import { API_BASES } from '../config';

const GATEWAY_BASE_URL = API_BASES.gateway; // ✅ usar gateway

// ---- Helper para refresh local ----
const AUTH_API = axios.create({
  baseURL: `${GATEWAY_BASE_URL}/api/auth`,
  headers: { 'Content-Type': 'application/json' },
});

async function refreshAccessTokenLocal() {
  const rt = localStorage.getItem('refreshToken');
  if (!rt) return null;
  try {
    const { data } = await AUTH_API.post('/refresh', { refreshToken: rt });
    if (data?.accessToken) {
      localStorage.setItem('accessToken', data.accessToken);
      if (data.refreshToken) localStorage.setItem('refreshToken', data.refreshToken);
      return data.accessToken;
    }
    return null;
  } catch {
    return null;
  }
}

// ---- Instancias Axios ----
export const CART_API = axios.create({
  baseURL: `${GATEWAY_BASE_URL}/api/orders/cart`,
  headers: { 'Content-Type': 'application/json' },
});

export const ORDER_API = axios.create({
  baseURL: `${GATEWAY_BASE_URL}/api/orders`,
  headers: { 'Content-Type': 'application/json' },
});

// ---- Attach token ----
const attachAuth = (config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
};
CART_API.interceptors.request.use(attachAuth);
ORDER_API.interceptors.request.use(attachAuth);

// ---- Retry 401 ----
const make401Retry = (instance) =>
  instance.interceptors.response.use(
    r => r,
    async (error) => {
      const status = error?.response?.status;
      const original = error?.config;
      if ((status === 401 || status === 403) && original && !original._retry) {
        original._retry = true;
        const newToken = await refreshAccessTokenLocal();
        if (newToken) {
          original.headers.Authorization = `Bearer ${newToken}`;
          return instance.request(original);
        }
      }
      return Promise.reject(error);
    }
  );

make401Retry(CART_API);
make401Retry(ORDER_API);

// === Endpoints (sin cambios funcionales) ===
export function getCart() { return CART_API.get(''); }
export function getCartCount() { return CART_API.get('/count'); }
export function addToCart(productId, precioUnitario) {
  return CART_API.post(`/${productId}`, null, { params: { precio: precioUnitario } });
}
export function removeFromCart(productId) { return CART_API.delete(`/${productId}`); }
export const createManualOrder = (request) => ORDER_API.post('/manual', request);
export const uploadReceiptForOrder = (orderId, formData) =>
  ORDER_API.post(`/${orderId}/receipt`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getOrdersPendingReceiptReview = (page = 0, size = 10) =>
  ORDER_API.get(`/pending-receipts?page=${page}&size=${size}`);
export const reviewManualPayment = (orderId, approve, comment) =>
  ORDER_API.put(`/admin/orders/${orderId}/review-payment?approve=${approve}`, { comment });
export function getMyOrders(status) {
  const params = status ? { status } : {};
  return ORDER_API.get('/my-orders', { params });
}
export function downloadOrder(orderId) {
  return ORDER_API.get(`/${orderId}/download`, { responseType: 'blob' });
}
export const downloadOrderBlob = (downloadUrl) =>
  ORDER_API.get(downloadUrl, { responseType: 'arraybuffer' });
export function acquireFreeProduct(productId) {
  return ORDER_API.post(`/${productId}/acquire`).then(r => r.data);
}
export async function getCartCountSafe() {
  try {
    const resp = await CART_API.get('/count');
    const data = resp?.data;
    if (typeof data === 'number') return data;
    if (typeof data?.count === 'number') return data.count;
    return 0;
  } catch (e) {
    if (e?.response?.status === 401) return 0;
    throw e;
  }
}
